"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_TYPE_KEY = exports.USER_TYPE_AUTHOR = exports.URL_PUBLIC_REPORT = exports.URL_PUBLIC_PING = exports.URL_PUBLIC_CONFIG = exports.LOGGING_METHOD_XAPI = exports.LOGGING_METHOD_REQUEST = exports.HTML_DATA_ATTR_INJECTED = exports.HEADER_KEY_DATE = exports.EXP_UUIDV4 = exports.DOWNLOAD_FILE_EXTENSIONS = exports.DOM_PURIFY_OPTIONS = exports.CONTENT_FRAGMENT_TYPE_TEST = exports.CONTENT_FRAGMENT_TYPE_DEFAULT = void 0;
const CONTENT_FRAGMENT_TYPE_DEFAULT = exports.CONTENT_FRAGMENT_TYPE_DEFAULT = "cfid";
const CONTENT_FRAGMENT_TYPE_TEST = exports.CONTENT_FRAGMENT_TYPE_TEST = "tfid";
const EXP_UUIDV4 = exports.EXP_UUIDV4 = "[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}";
const HEADER_KEY_DATE = exports.HEADER_KEY_DATE = "Date";
const HTML_DATA_ATTR_INJECTED = exports.HTML_DATA_ATTR_INJECTED = "data-inj";
const LOGGING_METHOD_XAPI = exports.LOGGING_METHOD_XAPI = "xapi";
const LOGGING_METHOD_REQUEST = exports.LOGGING_METHOD_REQUEST = "request";

// URL_PUBLIC_CONFIG is dynamically rewritten at request-time via Apache VirtualHost Config;
const URL_PUBLIC_CONFIG = exports.URL_PUBLIC_CONFIG = `${process.env.PUBLIC_URL}/configuration.json`;
const URL_PUBLIC_PING = exports.URL_PUBLIC_PING = `${process.env.PUBLIC_URL}/ping`;
const URL_PUBLIC_REPORT = exports.URL_PUBLIC_REPORT = `${process.env.PUBLIC_URL}/report`;
const USER_TYPE_AUTHOR = exports.USER_TYPE_AUTHOR = "author";
const USER_TYPE_KEY = exports.USER_TYPE_KEY = "userType";
const DOM_PURIFY_OPTIONS = exports.DOM_PURIFY_OPTIONS = {
  ADD_ATTR: ["target"],
  ADD_TAGS: ["pheaa-alert", "pheaa-announcement", "pheaa-banner-ad", "pheaa-download-card", "pheaa-help-text"],
  FORBID_ATTR: ["style"],
  FORBID_TAGS: ["script", "style"]
};
const DOWNLOAD_FILE_EXTENSIONS = exports.DOWNLOAD_FILE_EXTENSIONS = ["doc", "docm", "docx", "dot", "dotm", "dotx", "pot", "potx", "pps", "ppsx", "ppt", "pptx", "pub", "sldx", "xls", "xlsx", "xlt", "xltx"];